// extracted by mini-css-extract-plugin
export var readonly = "_ez-1";
export var star = "_ez-0";